const ClarityScriptLoad = () => {
  const microsoft_clarity_key = document.location.href.includes('https://sip.ketto.org/') ? 'f9y7bhc3fx' : 'f5d5n1q3au';
  (function (c, l, a, r, i, t, y) {
    // eslint-disable-next-line prefer-rest-params
    c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
    t = l.createElement(r); t.async = 1; t.src = 'https://www.clarity.ms/tag/' + i;
    y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
  }(window, document, 'clarity', 'script', `${microsoft_clarity_key}`));
};

export default ClarityScriptLoad;
